import React from 'react'
import { nflTeamImage } from '@severed-links/common.redherrings-constants'
import * as s from './FavoriteUnderdogButton.scss'

const FavoriteUnderdogButton = ({ game = {}, pick = 'Favorite', onClick, disabled = false }) => {
  const picked = game.pick === pick
  const favorite = pick === 'Favorite'
  const home = favorite ? !!game.homeFavorite : !game.homeFavorite
  const prefix = pick.toLowerCase()
  const name = game[`${prefix}Team`] || game[`${prefix}Mascot`] || game[`${prefix}TeamMobile`]
  return (
    <button type='button' disabled={disabled} aria-pressed={picked}
      aria-label={`${name}, ${pick.toLowerCase()}, ${home ? 'home' : 'away'}`}
      className={`${s.container} ${picked ? s.isPicked : ''}`}
      onClick={() => onClick?.(game.game, pick)}>
      <img className={s.teamImage} src={nflTeamImage(game[`${prefix}Mascot`])} alt='' />
      <span className={s.teamText}>
        <strong className={s.teamName}>{name}</strong>
        <strong className={s.teamAbbrev}>{game[`${prefix}TeamMobile`] || name}</strong>
        <span className={s.detail}>{home ? 'Home' : 'Away'}{game[`${prefix}Record`] ? ` · ${game[`${prefix}Record`]}` : ''}</span>
      </span>
      <span className={s.selection} aria-hidden='true'>{picked ? '✓' : ''}</span>
    </button>
  )
}

export default FavoriteUnderdogButton
